import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../../styles/components/project.scss";
import CustomCursor from "../../Cursor";
import { Link } from "react-router-dom";
import Video1 from "../../../media/creative-coding/Bubble/bubble-full-1.mp4";
import Video2 from "../../../media/creative-coding/Bubble/bubble-full-2.mp4";
import Video3 from "../../../media/creative-coding/Bubble/bubble-full-3.mp4";

export default function Bubble() {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="project-focus spacing-block" style={{ paddingTop: "10vh" }}>
      <div className="content">
        <h2 className="title text-6xl">Bubble</h2>
        <h3 className="year text-4xl">2020</h3>
        {/* VIDEO */}
        <video
          className="video"
          autoPlay
          muted
          loop
          controls
          src={Video1}
        ></video>

        {/* DESCRIPTION */}
        <div className="description">
          <h4 className="text-4xl">{t("creative_coding.bubble.title")}</h4>
          <p className="text-2xl" style={{ textAlign: "center" }}>
            {t("creative_coding.bubble.text")}
          </p>
        </div>

        {/* VIDEO */}
        <video
          className="video"
          autoPlay
          muted
          loop
          controls
          src={Video2}
        ></video>
        <div style={{ marginBottom: "5vh" }}></div>
        {/* VIDEO */}
        <video
          className="video"
          autoPlay
          muted
          loop
          controls
          src={Video3}
        ></video>

        <Link to="/creative-coding" style={{ color: "inherit" }}>
          <h3 className="close-text text-4xl animated-cursor">
            {t("creative_coding.back")}
          </h3>
        </Link>
      </div>
      <CustomCursor />
    </div>
  );
}
